export default __webpack_public_path__ + "static/media/image8.dd1f58c5.jpg";